export default {
    '/': 'Hem',
    '/bli-medlem': 'BliMedlem',
    '/kontakt': 'Kontakt',
    '/koren': 'Koren',
    '/korledare': 'Korledare',
    '/korledarna': 'Korledarna',
    '/se-och-lyssna': 'SeOchLyssna',
    '/sponsorer': 'Sponsorer'
  }